import "./App.css";
import Home from "./Components/Home";
import { login, logout } from "./Features/userSlice";
import { useDispatch } from "react-redux";
import Login from "./Components/auth/Login";
import { React, useEffect } from "react";
import db, { auth } from "./firebase";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      if (user) {
        db.collection("users")
          .where("uid", "==", auth.currentUser.uid)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              dispatch(
                login({
                  displayName: doc.data().displayName,
                  email: doc.data().email,
                  photo: doc.data().photo,
                  uid: doc.data().uid,
                })
              );
            });
          })
          .catch((error) => {
            console.log("Error getting documents: ", error);
          });
      } else {
        dispatch(logout());
      }
    });
  }, [dispatch]);

  return (
    <Router>
      <Switch>
        <div className="app">
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="/login">
            <Login />
          </Route>
        </div>
      </Switch>
    </Router>
  );
}

export default App;
